export default __webpack_public_path__ + "static/media/icons8-microsoft-excel.a5996787.png";